import { Text } from "@solomon-apps/shared/src/components/ui/text";
import React from "react";

/**
 * The heads-up under a destination address that `looksLikeExchangeAddress`.
 * A heuristic, so it warns and never blocks. Used by the Add a Position
 * destination picker; the add-destination form shows it as an Exchange
 * Address badge in the field instead.
 */
export function ExchangeAddressWarning(): React.ReactElement {
    return (
        <Text variant="label" className="mt-1.5 text-accent-base">
            Heads up, this looks like a known exchange deposit address. Rewards
            sent there may be lost.
        </Text>
    );
}
